import { render, staticRenderFns } from "./intreabaunbibliotecar.vue?vue&type=template&id=c1455f5c&"
import script from "./intreabaunbibliotecar.vue?vue&type=script&lang=js&"
export * from "./intreabaunbibliotecar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports